import React, { useState } from "react";
import styled from "styled-components";

const Container = styled("div")(() => ({
  display: 'flex',
  justifyContent: "center",
  justifyItems: 'center'
}));

const Card = styled.div`
  position: relative;
  flex-basis: 100%;
  max-width: 600px;
  min-height: 600px;
  
`;

const CardTemplate = styled("div")(() => ({
  height: '100%',
  backfaceVisibility: "hidden",
  // borderRadius: "6px",
  transformStyle: "preserve-3d",
  transition: "transform 1s cubic-bezier(0.8, 0.3, 0.3, 1)"
}));

const CardFront = styled(CardTemplate)(({ flip }) => ({

  backgroundImage: "url('images/cardimage.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  transform: flip ? "rotateY(-180deg)" : "rotateY(0deg)",
  transformOrigin: 'center'
}));

const CardBack = styled(CardTemplate)(({ flip }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width:'100%',
  backgroundSize: "cover",
  backgroundPosition: "center",
  // background: "linear-gradient(0deg, #00adb5 20%,#596a72 100%)",
  transform: flip ? "rotateY(0deg)" : "rotateY(180deg)",
  
}));

const CardContent = styled("div")(() => ({
  justifyItems: 'center',
  position: "relative",
  width: "100%",
  backfaceVisibility: "hidden",
  transform: "translateZ(70px) scale(0.90)",
  transition:'0.10s',

}));

const BGFade = styled("div")(() => ({
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  height: "200px",
  background: "linear-gradient(to bottom, rgba(0,0,0,0) 20%,rgba(0,0,0,.8) 90%)"
}));
function Co({ p }) {
    const[flip,setFlip]=useState(false)
    const[hover,setHover]=useState(false)
    
    return (
        <div className=" flex items-center justify-center    ">
          <div className={`$ bg-transparent mb-4 shadow-2xl shadow-rb  border-4  rounded-tr-3xl rounded-bl-3xl border-gray-400`}>
            <Card
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              className={` ${flip? ' bg-black rounded-tr-3xl rounded-bl-3xl shadow-inner shadow-sky-500 flex items-center ' : 'transition-all ease-in-out duration-1000 hover:bg-black hover:shadow-inner hover:shadow-sky-500 rounded-tr-3xl rounded-bl-3xl flex items-center'}`}
              >
                <div />
              <CardFront flip={flip} className='transition-all ease-in-out duration-1000'>
              <CardContent className="  text-center text-white flex flex-col  gap-1 justify-center items-center">
                <h1 className={`${hover ? '   text-4xl font-semibold text-white ' :'hidden' }  `}>{p.title}</h1>
                {p.event && <h2 className={`${hover ? ' text-yellow-500 font-semibold px-4' :'hidden' }`}>{p.event.name} · {p.event.date}</h2>}
                <h2 className={`${hover ? '   ' :'hidden' }  `}>Features Include:</h2>
                <ol className={`${hover ? '   ' :'hidden' }  `}>
                {Object.values(p.features).map((t, index) => {
                      return <li key={index} className="text-sm">{t}</li>
                    })}
                </ol>
              <div className="md:h-[20rem] md:w-[20rem] h-[25rem] w-[25rem] flex items-center justify-center flex-col"  >
                <div> {p.image}</div>
                   <button onClick={()=>setFlip(!flip)} className={` ${hover  ? ' border-2 rounded border-white py-2 hover:bg-rb px-5  text-white' : 'hidden'}  `  }>More Info </button>
                </div>
                </CardContent>
              </CardFront>
              <CardBack flip={flip} className=" bg-black shadow-inner shadow-rb flex items-center justify-center flex-col  rounded-tr-3xl rounded-bl-3xl">
                <CardContent className="text-white text-center  flex flex-col gap-5 justify-center items-center">
                  <div className={`${flip? '': 'hidden'} w-full h-[13rem] rounded-2xl  flex items-center justify-center`}>
                    {p.prev}
                    </div>
                  <div className="flex gap-2">
                    {Object.values(p.techs).map((t, index) => {
                      return <div key={index}>{t}</div>
                    })}

                  </div>
                  <p>{p.description}</p>
                <div className="flex flex-col items-center gap-4 md:gap-3">
                  {(p.devpost || p.repo || p.link) && (
                    <div className="flex flex-wrap justify-center gap-4 md:gap-2">
                      {p.devpost && <a href={p.devpost} target="_blank" rel="noreferrer" className="inline-block border-2 rounded border-white py-2 px-5 md:px-3 md:text-sm text-white hover:bg-sky-600">Devpost</a>}
                      {p.repo && <a href={p.repo} target="_blank" rel="noreferrer" className="inline-block border-2 rounded border-white py-2 px-5 md:px-3 md:text-sm text-white hover:bg-purple-600">GitHub</a>}
                      {p.link && <a href={p.link} target="_blank" rel="noreferrer" className="inline-block border-2 rounded border-white py-2 px-5 md:px-3 md:text-sm text-white hover:bg-green-500">Visit Site</a>}
                    </div>
                  )}
                  <button onClick={()=>setFlip(!flip)} className="border-2 rounded border-white py-2 hover:bg-red-500 px-5 text-white">Go Back </button>
                </div>
                   
                </CardContent>
              </CardBack>
            </Card>
          </div>
        </div>
      );
    }

export default Co;
